import React from 'react';
import { Redirect, Route } from '@americanexpress/one-app-router';

const childRoutes = () => [
  <Redirect key="/" from="/" to="/passkey" />,
  <Route key="passkey" path="/passkey" />,
  <Route key="id" path="/passkey/:uniqueId" />,
];

export default childRoutes;
